import { memo, useCallback, useMemo } from 'react';
import { RackingArea } from '@thive/fddm-types';

import { SelectInput } from '@/modules/common/components/inputs';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { getCommonOption } from '@/modules/common/helpers/commonValue';
import {
  createEmptyAreas,
  pushAreaToItsCollection,
} from '@/modules/floorplanDesign/helpers/helpers';
import { useTranslatedOptions } from '@/modules/common/hooks';

const STACKING_OPTIONS: { labelKey: string; value: RackingArea['stacking'] }[] = [
  { labelKey: 'interface:properties.area.rack.alignment_options.top', value: 'HORIZONTAL_TOP' },
  {
    labelKey: 'interface:properties.area.rack.alignment_options.middle',
    value: 'HORIZONTAL_MIDDLE',
  },
  {
    labelKey: 'interface:properties.area.rack.alignment_options.bottom',
    value: 'HORIZONTAL_BOTTOM',
  },
];

interface Props {
  selectedRackingAreas: RackingArea[];
}

function AlignmentComponent({ selectedRackingAreas }: Props) {
  const stackingOptions = useTranslatedOptions(STACKING_OPTIONS);
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const stacking = useMemo(
    () => getCommonOption(selectedRackingAreas.map((area) => area.stacking)),
    [selectedRackingAreas],
  );

  const onChange = useCallback(
    (newValue: RackingArea['stacking']) => {
      fddmSvc.setPreference('rackingArea.stacking', newValue);

      const updatedAreas = createEmptyAreas();
      selectedRackingAreas.forEach((area) => {
        pushAreaToItsCollection(updatedAreas, { ...area, stacking: newValue });
      });
      fddmSvc.updateAreas(updatedAreas);
    },
    [fddmSvc, selectedRackingAreas],
  );

  return <SelectInput options={stackingOptions} onChange={onChange} value={stacking} showMixed />;
}

const Alignment = memo(AlignmentComponent);

export default Alignment;
